import { gql } from "@apollo/client"

export const ReimbursementBudgetFragment = gql`
  fragment ReimbursementBudgetFragment on ReimbursementBudget {
    id
    label
    amount {
      subunit
      formatted
      currencyCode
    }
    changeReason
    customLabel
    effectiveDate
    effectiveEndDate
    resetFrequency
  }
`
